import { GridPageChangeParams, GridRowData, GridSortModel } from '@material-ui/data-grid'
import React, { useEffect } from 'react'
import * as searchTypes from './searchType'
import { generatePath, useHistory } from 'react-router-dom'
import { RoutePath } from '../../../../router/routesConfig'
import useAuthenStore from '../../../../stores/authen/authenStore'
import useWebService from '../../../../services/web/useWebService'
import { renderMode } from '../../../../constants/constants'
import constSubmittedStatus from '../../../../constants/submittedStatus'
import * as _ from 'lodash'
import useLoading from '../../../../control/loading/useLoading'
import { encryptionAES } from '../../../../utilities/encryption'
import useTranslate from '../../../../i18n/useTranslate'
import constUserGroup from '../../../../constants/userGroup'
import { useQueryParam } from 'use-query-params'
import constProjectStatus from '../../../../constants/projectStatus'
import useCheckPermission from '../../../../utilities/checkPermission'

const useSearch = (props: searchTypes.UseSearchType) => {
    const {} = props
    const { configLoading, loadingClose, loadingOpen } = useLoading()
    const profileStore = useAuthenStore()
    // const [currentListIndex, setCurrentListIndex] = React.useState<number>(1)
    const [isGotoTop, setIsGotoTop] = React.useState<boolean>(false)
    const { profile } = profileStore
    const translate = useTranslate()
    const displayRole =
        translate.languageStore.currentLanguage === translate.languageKey.th
            ? profile.userGroupName_th?.replace('(', '').replace(')', '')
            : profile.userGroupName_en?.replace('(', '').replace(')', '')

    const [listItem, setListItem] = React.useState<searchTypes.TReturnList[]>([])
    const [isSumItem, setIsSumItem] = React.useState<number>(0)
    const [isPage, setIsPage] = React.useState<number>(0)
    const [isShowForm, setIsShowForm] = React.useState<boolean>(true)
    const history = useHistory()
    const callWebService = useWebService()
    const [paramSearch, setParamSearch] = React.useState<searchTypes.ListRequestType>()
    const paramSearchRef = React.useRef<searchTypes.ListRequestType>()
    const formatParams = React.useRef<any>({})
    // const [isResearcher, setIsResearcher] = React.useState<boolean>(false)
    const [sortModel, setSortModel] = React.useState<GridSortModel>([{ field: 'name', sort: 'asc' }])
    const [paginationModel, setPaginationModel] = React.useState<GridPageChangeParams>({
        page: 0,
        pageCount: 10,
        pageSize: 10,
        paginationMode: 'server',
        rowCount: 100,
    })
    const [keyword, setKeyword] = useQueryParam<number | null>('keyword')
    const [submittedType, setSubmittedType] = useQueryParam<string | null>('submittedType')

    const [status, setStatus] = useQueryParam<string | null>('status')
    const [submittedStatusList, setSubmittedStatus] = useQueryParam<string | null>('submittedStatus')
    const [submittedConsiderTypeIdList, setSubmittedConsiderTypeIdList] = useQueryParam<string | null>(
        'submittedConsiderTypeId',
    )
    const [pendingAndRiskList, setPendingAndRiskList] = useQueryParam<string | null>('pendingAndRisk')
    const [progressOverdueList, setProgressOverdueList] = useQueryParam<string | null>('progressOverdue')
    const [onlyCurrentYearParam, setOnlyCurrentYearParam] = useQueryParam<string | null | undefined>(
        'onlyCurrentYear',
    )

    const rowPerpage = 10
    const [initialValueForm, setInitialValueForm] = React.useState<any>()
    const checkPermission = useCheckPermission()

    const currentListIndexRef = React.useRef<number>(1)
    const authenStoreRef = React.useRef<ReturnType<typeof useAuthenStore>>()
    const searchParamRef = React.useRef<searchTypes.ListRequestType>()
    const dashboardSkipNextQueryEffectRef = React.useRef<boolean>(false)

    const setSearchParam = (value: any) => {
        setKeyword(value.keywordSearch)
        setSubmittedType(value.projectSubmitType)
        setStatus(value.status)
        setSubmittedStatus(value.submittedStatus)
        setSubmittedConsiderTypeIdList(value.submittedConsiderTypeId)
        setPendingAndRiskList(value.pendingAndRisk)
        setProgressOverdueList(value.progressOverdue)
        setOnlyCurrentYearParam(value.onlyCurrentYear ? '1' : undefined)
    }

    useEffect(() => {
        //don't set state here
        authenStoreRef.current = profileStore
    })

    useEffect(() => {
        if (profile.userId) {
            const param = formatParams.current
            let projectSubmittedStatusId
            let projectStatusId
            switch (profile.userGroupId) {
                case constUserGroup.officer: //เจ้าหน้าที่
                    projectSubmittedStatusId = [
                        // constSubmittedStatus.draft,
                        constSubmittedStatus.sent,
                        constSubmittedStatus.received,
                        constSubmittedStatus.directorAssigned,
                        constSubmittedStatus.waitingSentReviewer,
                        constSubmittedStatus.waitSynthesis,
                        constSubmittedStatus.proceedingCertificate,
                        constSubmittedStatus.waitSign,
                        constSubmittedStatus.incorrectDocument,
                        constSubmittedStatus.resultConsideration,
                        constSubmittedStatus.considering,
                        constSubmittedStatus.waitingSetCopies,
                        constSubmittedStatus.ProceedingMemoMessage,
                        constSubmittedStatus.waitingEditProject,
                    ]
                    projectStatusId = [constProjectStatus.processing]
                    break
                case constUserGroup.committee:
                    projectSubmittedStatusId = [constSubmittedStatus.considering] // id กำลังพิจารณา
                    projectStatusId = [constProjectStatus.processing]
                    break
                case constUserGroup.president:
                case constUserGroup.vicePresident:
                case constUserGroup.secretary:
                case constUserGroup.reviewer:
                    if (profile?.irb == 2) {
                        projectSubmittedStatusId = [
                            constSubmittedStatus.received,
                            constSubmittedStatus.waitSynthesis,
                            constSubmittedStatus.waitSign,
                            constSubmittedStatus.considering,
                        ]
                    } else {
                        projectSubmittedStatusId = [
                            constSubmittedStatus.sent,
                            constSubmittedStatus.received,
                            //constSubmittedStatus.directorAssigned,
                            constSubmittedStatus.waitSynthesis,
                            constSubmittedStatus.proceedingCertificate,
                            constSubmittedStatus.waitSign,
                            //constSubmittedStatus.incorrectDocument,
                            constSubmittedStatus.resultConsideration,
                            constSubmittedStatus.considering,
                            constSubmittedStatus.waitingSetCopies,
                            //constSubmittedStatus.ProceedingMemoMessage,
                            //constSubmittedStatus.waitingEditProject,
                        ] // id รับเรื่องแล้ว,รอสังเคราะห์,รอลงนาม,กำลังพิจารณา
                    }
                    projectStatusId = [constProjectStatus.processing]
                    break
                default:
                    break
            }

            const params = {
                userId:
                    profileStore && profileStore.profile && profileStore.profile.userId
                        ? profileStore.profile.userId
                        : undefined,
                sortingCol: param && param.sortingCol ? param.sortingCol : undefined,
                sortingType: param && param.sortingType ? param.sortingType : undefined,
                pageNumber: param && param.pageNumber ? param.pageNumber : 1,
                rowsPerPage: rowPerpage,
                keywordSearch: param && param.keywordSearch ? param.keywordSearch : undefined,
                projectSubmitTypeId: param && param.projectSubmitTypeId ? param.projectSubmitTypeId : undefined,
                projectStatusId: projectStatusId ? projectStatusId : undefined,
                submittedStatusId: projectSubmittedStatusId ? projectSubmittedStatusId : undefined,
            }
            setParamSearch(params)
            paramSearchRef.current = params

            if (typeof status === 'string') {
                params.projectStatusId = status.split(',').map(Number)
            }

            if (typeof submittedType === 'string') {
                params.projectSubmitTypeId = submittedType.split(',').map(Number)
            }

            if (typeof keyword === 'string') {
                params.keywordSearch = keyword
            }

            if (typeof submittedStatusList === 'string') {
                params.submittedStatusId = submittedStatusList.split(',').map(Number)
            }

            const hasQueryFilter = !!(
                submittedStatusList ||
                submittedConsiderTypeIdList ||
                submittedType ||
                pendingAndRiskList ||
                progressOverdueList ||
                onlyCurrentYearParam ||
                status ||
                keyword
            )
            const isHandledByQueryEffect = hasQueryFilter || profile.userGroupId === constUserGroup.researcher

            if (profile?.userGroupId && !isHandledByQueryEffect) {
                getListTbl(params)
            }

            createInitialFrom()
        }
    }, [sortModel, paginationModel, profile.userId])

    const getListTbl = async (param: searchTypes.ListRequestType) => {
        searchParamRef.current = param
        loadingOpen()

        try {
            const res = await callWebService.searchTbl(param, `${authenStoreRef.current?.profile.userGroupId}`)
            const list =
                res?.result?.items?.map((item, index) => {
                    return {
                        id: index,
                        ...item,
                    }
                }) ?? []

            setIsSumItem(res?.result?.totalRecords ?? 0)
            setListItem(list)
        } catch (error) {
            console.error('getListTbl error:', error)
            setIsSumItem(0)
            setListItem([])
        } finally {
            loadingClose()
        }
    }

    const getListItem = async (params: searchTypes.TReturnForm) => {
        //เมื่อกด search จะเข้า function นี้ก่อน
        const listProjectSubmitTypeId = params?.projectSubmitType?.map((itm: string) => {
            return parseInt(itm)
        })

        const listStatusID = params?.status?.map((itm: string) => {
            return parseInt(itm)
        })

        const listSubmittedStatus = csvToIdObjs(params?.submittedStatus?.join(','))
        const listProjectSubmitType = csvToIdObjs(params?.projectSubmitType?.join(','))
        const listSubmittedConsiderType = csvToIdObjs(params?.submittedConsiderTypeId?.join(','))

        const listSubmissionID = params?.submittedStatus?.map((itm: string) => {
            return parseInt(itm)
        })

        const listSubmittedConsiderTypeId = params?.submittedConsiderTypeId?.map((itm: string) => {
            return parseInt(itm)
        })

        const listProgressOverdue = params?.progressOverdue?.map((itm: string) => {
            return parseInt(itm)
        })

        const listPendingAndRisk = params?.pendingAndRisk?.map((itm: string) => {
            return parseInt(itm)
        })

        const paramsSearch = {
            userId:
                profileStore && profileStore.profile && profileStore.profile.userId
                    ? profileStore.profile.userId
                    : undefined,
            pageNumber: 1,
            rowsPerPage: rowPerpage,
            keywordSearch: params && params.keywordSearch ? params.keywordSearch : undefined,
            projectStatusId: params && params.status && params.status.length > 0 ? listStatusID : undefined,
            onlyMe: params.onlyMe,
            onlyPreliminary: params.onlyPreliminary,
            researcherDraft: params.researcherDraft,
            doAndDoneCommentary: params.doAndDoneCommentary,
            submittedStatusFilter: params?.submittedStatus?.length ? listSubmittedStatus : undefined,
            submittedTypeFilter: params?.projectSubmitType?.length ? listProjectSubmitType : undefined,
            submittedConsiderTypeFilter: params?.submittedConsiderTypeId?.length
                ? listSubmittedConsiderType
                : undefined,
            onlyProgress: params.progressOverdue?.includes('1') || undefined,
            onlyOverdue: params.progressOverdue?.includes('2') || undefined,
            onlyPending: params.pendingAndRisk?.includes('1') || undefined,
            // onlyPendingOverdue: params.pendingAndRisk?.includes('1') || undefined,
            onlyRisk: params.pendingAndRisk?.includes('2') || undefined,
        }
        formatParams.current = {
            ...paramsSearch,
        }

        const searchValue = {
            status: params && params.status && params.status.length > 0 ? listStatusID : undefined,
            keywordSearch: params && params.keywordSearch ? params.keywordSearch : undefined,
            projectSubmitType:
                params && params.projectSubmitType && params.projectSubmitType.length > 0
                    ? listProjectSubmitTypeId
                    : undefined,
            submittedStatus:
                params && params.submittedStatus && params.submittedStatus.length > 0 ? listSubmissionID : undefined,
            onlyMe: params?.onlyMe ? params?.onlyMe : false,
            researcherDraft: params?.researcherDraft ? params?.researcherDraft : false,
            doAndDoneCommentary: params?.doAndDoneCommentary ? params?.doAndDoneCommentary : false,
            submittedConsiderTypeId:
                params && params.submittedConsiderTypeId && params.submittedConsiderTypeId.length > 0
                    ? listSubmittedConsiderTypeId
                    : undefined,
            progressOverdue:
                params && params.progressOverdue && params.progressOverdue.length > 0 ? listProgressOverdue : undefined,
            pendingAndRisk:
                params && params.pendingAndRisk && params.pendingAndRisk.length > 0 ? listPendingAndRisk : undefined,
        }

        dashboardSkipNextQueryEffectRef.current = true

        setIsGotoTop(true)
        // setCurrentListIndex(1)
        currentListIndexRef.current = 1
        setParamSearch(paramsSearch)
        paramSearchRef.current = paramsSearch

        setSearchParam(searchValue)
        getListTbl(paramsSearch)
        setIsPage(0)
    }

    const handleClickEdit = (row: GridRowData) => {
        const encryptedProjectID = encryptionAES(row.projectID)
        const encryptedSubmittedID = encryptionAES(row.submittedID)
        const idDraft = row.is_draft === 1 ? true : false

        const path = generatePath(RoutePath.manageProjectEdit, {
            projectID: encryptedProjectID,
            submittedID: encryptedSubmittedID,
        })

        if (idDraft) {
            // const pathEdit = generatePath(RoutePath.manageProjectEdit, {
            //     projectID: encryptedProjectID,
            //     submittedID: encryptedSubmittedID,
            // })
            history.push({
                pathname: path,
                state: {
                    // location state
                    irb: row.irb,
                    mode: renderMode.edit,
                },
            })
        } else {
            // const pathView = generatePath(RoutePath.manageProjectEdit, {
            //     projectID: encryptedProjectID,
            //     submittedID: encryptedSubmittedID,
            // })
            history.push({
                pathname: path,
                state: {
                    // location state
                    irb: row.irb,
                    mode: renderMode.view,
                },
            })
        }
    }
    const handleClickCreate = () => {
        history.push(RoutePath.manageProjectCreateRequest)
    }
    const handleClickSearch = () => {
        setIsShowForm(!isShowForm)
    }

    /**
     * process clear form
     */
    const handleClickClear = () => {
        const params = defaultSearch()
        defaultFormSearch()
        setIsGotoTop(true)
        currentListIndexRef.current = 1
        getListTbl(params)
    }

    const defaultFormSearch = () => {
        let submittedStatus
        let projectStatusId
        switch (profile.userGroupId) {
            case constUserGroup.officer: //เจ้าหน้าที่
                submittedStatus = [
                    // constSubmittedStatus.draft.toString(),
                    constSubmittedStatus.sent.toString(),
                    constSubmittedStatus.received.toString(),
                    constSubmittedStatus.directorAssigned.toString(),
                    constSubmittedStatus.waitingSentReviewer.toString(),
                    constSubmittedStatus.waitSynthesis.toString(),
                    constSubmittedStatus.proceedingCertificate.toString(),
                    constSubmittedStatus.waitSign.toString(),
                    constSubmittedStatus.incorrectDocument.toString(),
                    constSubmittedStatus.resultConsideration.toString(),
                    constSubmittedStatus.considering.toString(),
                    constSubmittedStatus.waitingSetCopies.toString(),
                    constSubmittedStatus.ProceedingMemoMessage.toString(),
                    constSubmittedStatus.waitingEditProject.toString(),
                ]
                projectStatusId = [constProjectStatus.processing.toString()]
                break
            case constUserGroup.committee: //กรรมการ
                submittedStatus = [constSubmittedStatus.considering.toString()] // id กำลังพิจารณา
                projectStatusId = [constProjectStatus.processing.toString()]
                break
            case constUserGroup.president:
            case constUserGroup.vicePresident:
            case constUserGroup.secretary:
            case constUserGroup.reviewer:
                if (profile?.irb == 2) {
                    submittedStatus = [
                        constSubmittedStatus.received.toString(),
                        constSubmittedStatus.waitSynthesis.toString(),
                        constSubmittedStatus.waitSign.toString(),
                        constSubmittedStatus.considering.toString(),
                    ]
                } else {
                    submittedStatus = [
                        constSubmittedStatus.sent.toString(),
                        constSubmittedStatus.received.toString(),
                        //constSubmittedStatus.directorAssigned.toString(),
                        constSubmittedStatus.waitSynthesis.toString(),
                        constSubmittedStatus.proceedingCertificate.toString(),
                        constSubmittedStatus.waitSign.toString(),
                        //constSubmittedStatus.incorrectDocument.toString(),
                        constSubmittedStatus.resultConsideration.toString(),
                        constSubmittedStatus.considering.toString(),
                        constSubmittedStatus.waitingSetCopies.toString(),
                        //constSubmittedStatus.ProceedingMemoMessage.toString(),
                        //constSubmittedStatus.waitingEditProject.toString(),
                    ] // id รับเรื่องแล้ว,รอสังเคราะห์,รอลงนาม,กำลังพิจารณา
                }

                projectStatusId = [constProjectStatus.processing.toString()]
                break
            default:
                break
        }
        type initialFrom = {
            submittedStatus: string[] | undefined
            status: string | string[] | undefined
            keywordSearch: number | undefined
            projectSubmitType: string | string[] | undefined
        }

        const initialFrom: initialFrom = {
            submittedStatus: submittedStatus ? submittedStatus : undefined,
            status: projectStatusId ? projectStatusId : undefined,
            keywordSearch: undefined,
            projectSubmitType: undefined,
        }

        setInitialValueForm(initialFrom)
        setSearchParam(initialFrom)
    }

    const defaultSearch = () => {
        let projectSubmittedStatusId
        let projectStatusId
        switch (profile.userGroupId) {
            case constUserGroup.officer: //เจ้าหน้าที่
                projectSubmittedStatusId = [
                    // constSubmittedStatus.draft,
                    constSubmittedStatus.sent,
                    constSubmittedStatus.received,
                    constSubmittedStatus.directorAssigned,
                    constSubmittedStatus.waitingSentReviewer,
                    constSubmittedStatus.waitSynthesis,
                    constSubmittedStatus.proceedingCertificate,
                    constSubmittedStatus.waitSign,
                    constSubmittedStatus.incorrectDocument,
                    constSubmittedStatus.resultConsideration,
                    constSubmittedStatus.considering,
                    constSubmittedStatus.waitingSetCopies,
                    constSubmittedStatus.ProceedingMemoMessage,
                    constSubmittedStatus.waitingEditProject,
                ]
                projectStatusId = [constProjectStatus.processing]
                break
            case constUserGroup.committee:
                projectSubmittedStatusId = [constSubmittedStatus.considering] // id กำลังพิจารณา
                projectStatusId = [constProjectStatus.processing]
                break
            case constUserGroup.president:
            case constUserGroup.vicePresident:
            case constUserGroup.secretary:
            case constUserGroup.reviewer:
                if (profile?.irb == 2) {
                    projectSubmittedStatusId = [
                        constSubmittedStatus.received,
                        constSubmittedStatus.waitSynthesis,
                        constSubmittedStatus.waitSign,
                        constSubmittedStatus.considering,
                    ]
                } else {
                    projectSubmittedStatusId = [
                        constSubmittedStatus.sent,
                        constSubmittedStatus.received,
                        //constSubmittedStatus.directorAssigned,
                        constSubmittedStatus.waitSynthesis,
                        constSubmittedStatus.proceedingCertificate,
                        constSubmittedStatus.waitSign,
                        //constSubmittedStatus.incorrectDocument,
                        constSubmittedStatus.resultConsideration,
                        constSubmittedStatus.considering,
                        constSubmittedStatus.waitingSetCopies,
                        //constSubmittedStatus.ProceedingMemoMessage,
                        //constSubmittedStatus.waitingEditProject,
                    ] // id รับเรื่องแล้ว,รอสังเคราะห์,รอลงนาม,กำลังพิจารณา
                }

                projectStatusId = [constProjectStatus.processing]
                break
            default:
                break
        }

        const params = {
            userId:
                profileStore && profileStore.profile && profileStore.profile.userId
                    ? profileStore.profile.userId
                    : undefined,
            sortingCol: undefined,
            sortingType: undefined,
            pageNumber: 1,
            rowsPerPage: rowPerpage,
            keywordSearch: undefined,
            projectSubmitTypeId: undefined,
            projectStatusId: projectStatusId ? projectStatusId : undefined,
            submittedStatusId: projectSubmittedStatusId,
        }
        setParamSearch(params)
        paramSearchRef.current = params

        return params
    }
    /**
     * end process clear form
     */

    ////////////////////////////////////////////////////////////////////////////
    const totalRef = React.useRef(0)
    const loadedRef = React.useRef(0)

    useEffect(() => {
        totalRef.current = isSumItem
        loadedRef.current = listItem.length
    }, [isSumItem, listItem])

    const handleScrollEnd = (rowPerpage: number, currentIndex: number) => {
        setIsGotoTop(false)

        if (!paramSearchRef.current) return

        const total = totalRef.current
        const loaded = loadedRef.current

        if (loaded >= total) return

        currentListIndexRef.current = currentListIndexRef.current + 1
        getListTbl({ ...paramSearchRef.current, rowsPerPage: rowPerpage })
    }

    const handleClickGotoTop = () => {
        setIsGotoTop(true)
    }

    const createInitialFrom = () => {
        let submittedStatus
        let projectStatusId
        switch (profile.userGroupId) {
            case constUserGroup.officer: //เจ้าหน้าที่
                submittedStatus = [
                    // constSubmittedStatus.draft.toString(),
                    constSubmittedStatus.sent.toString(),
                    constSubmittedStatus.received.toString(),
                    constSubmittedStatus.directorAssigned.toString(),
                    constSubmittedStatus.waitingSentReviewer.toString(),
                    constSubmittedStatus.waitSynthesis.toString(),
                    constSubmittedStatus.proceedingCertificate.toString(),
                    constSubmittedStatus.waitSign.toString(),
                    constSubmittedStatus.incorrectDocument.toString(),
                    constSubmittedStatus.resultConsideration.toString(),
                    constSubmittedStatus.considering.toString(),
                    constSubmittedStatus.waitingSetCopies.toString(),
                    constSubmittedStatus.ProceedingMemoMessage.toString(),
                    constSubmittedStatus.waitingEditProject.toString(),
                ]
                projectStatusId = [constProjectStatus.processing.toString()]
                break
            case constUserGroup.committee: //กรรมการ
                submittedStatus = [constSubmittedStatus.considering.toString()] // id กำลังพิจารณา
                projectStatusId = [constProjectStatus.processing.toString()]
                break
            case constUserGroup.president:
            case constUserGroup.vicePresident:
            case constUserGroup.secretary:
            case constUserGroup.reviewer:
                if (profile?.irb == 2) {
                    submittedStatus = [
                        constSubmittedStatus.received.toString(),
                        constSubmittedStatus.waitSynthesis.toString(),
                        constSubmittedStatus.waitSign.toString(),
                        constSubmittedStatus.considering.toString(),
                    ]
                } else {
                    submittedStatus = [
                        constSubmittedStatus.sent.toString(),
                        constSubmittedStatus.received.toString(),
                        //constSubmittedStatus.directorAssigned.toString(),
                        constSubmittedStatus.waitSynthesis.toString(),
                        constSubmittedStatus.proceedingCertificate.toString(),
                        constSubmittedStatus.waitSign.toString(),
                        //constSubmittedStatus.incorrectDocument.toString(),
                        constSubmittedStatus.resultConsideration.toString(),
                        constSubmittedStatus.considering.toString(),
                        constSubmittedStatus.waitingSetCopies.toString(),
                        //constSubmittedStatus.ProceedingMemoMessage.toString(),
                        //constSubmittedStatus.waitingEditProject.toString(),
                    ] // id รับเรื่องแล้ว,รอสังเคราะห์,รอลงนาม,กำลังพิจารณา
                }

                projectStatusId = [constProjectStatus.processing.toString()]
                break
            default:
                break
        }
        type initialFrom = {
            submittedStatus: string[] | undefined
            status: string | string[] | undefined
            keywordSearch: number | undefined
            projectSubmitType: string | string[] | undefined
        }

        const initialFrom: initialFrom = {
            submittedStatus: (submittedStatus ?? submittedStatus) ? submittedStatus : undefined,
            status: status ?? (projectStatusId ? projectStatusId : undefined),
            keywordSearch: keyword ?? undefined,
            projectSubmitType: submittedType ?? undefined,
        }

        if (typeof status === 'string') {
            initialFrom.status = status.split(',')
        }

        if (typeof submittedType === 'string') {
            initialFrom.projectSubmitType = submittedType.split(',')
        }

        if (typeof submittedStatusList === 'string') {
            initialFrom.submittedStatus = submittedStatusList.split(',')
        }

        setInitialValueForm(initialFrom)
        setSearchParam(initialFrom)
    }

    const csvNums = (s?: string | null) =>
        typeof s === 'string' && s.trim() !== ''
            ? s
                  .split(',')
                  .map((t) => Number(t.trim()))
                  .filter((n) => Number.isFinite(n))
            : undefined

    const csvStrs = (s?: string | null) =>
        typeof s === 'string' && s.trim() !== ''
            ? s
                  .split(',')
                  .map((t) => t.trim())
                  .filter(Boolean)
            : undefined

    const csvToIdObjs = (s?: string | null): searchTypes.BaseDashboardFilter[] | undefined =>
        typeof s === 'string' && s.trim() !== ''
            ? s
                  .split(',')
                  .map((t) => t.trim())
                  .filter(Boolean)
                  .map((id) => ({ id: Number(id) }))
            : undefined

    useEffect(() => {
        if (!profile.userId) return

        if (
            !submittedStatusList &&
            !submittedConsiderTypeIdList &&
            !submittedType &&
            !pendingAndRiskList &&
            !progressOverdueList &&
            !onlyCurrentYearParam &&
            !status &&
            !keyword &&
            profile.userGroupId !== constUserGroup.researcher
        )
            return

        const initialFrom = {
            keywordSearch: typeof keyword === 'string' ? keyword : undefined,
            submittedStatus: csvStrs(submittedStatusList),
            status: csvStrs(status),
            projectSubmitType: csvStrs(submittedType),
            submittedConsiderTypeId: csvStrs(submittedConsiderTypeIdList),
            progressOverdue: csvStrs(progressOverdueList),
            pendingAndRisk: csvStrs(pendingAndRiskList),
        }
        setInitialValueForm(initialFrom)

        if (dashboardSkipNextQueryEffectRef.current) {
            dashboardSkipNextQueryEffectRef.current = false
            setIsShowForm(false)
            return
        }

        const params: searchTypes.ListRequestType = {
            userId: profile.userId,
            pageNumber: 1,
            rowsPerPage: rowPerpage,
        }

        const submittedStatusFilters = csvToIdObjs(submittedStatusList)
        if (submittedStatusFilters?.length) params.submittedStatusFilter = submittedStatusFilters

        const statusIds = csvNums(status)
        if (statusIds?.length) params.projectStatusId = statusIds

        const submittedTypeFilters = csvToIdObjs(submittedType)
        if (submittedTypeFilters?.length) params.submittedTypeFilter = submittedTypeFilters

        const submittedConsiderTypeFilters = csvToIdObjs(submittedConsiderTypeIdList)
        if (submittedConsiderTypeFilters?.length) params.submittedConsiderTypeFilter = submittedConsiderTypeFilters

        const overdueFlags = csvStrs(progressOverdueList)
        params.onlyOverdue = overdueFlags?.includes('2') || undefined
        params.onlyProgress = overdueFlags?.includes('1') || undefined
        params.onlyCurrentYear = onlyCurrentYearParam === '1' || undefined

        const pr = csvStrs(pendingAndRiskList)
        if (pr) {
            params.onlyPending = pr.includes('1') || undefined
            // params.onlyPendingOverdue = pr.includes('1') || undefined
            params.onlyRisk = pr.includes('2') || undefined
        }

        if (paramSearchRef.current && _.isEqual(paramSearchRef.current, params)) {
            setIsShowForm(false)
            return
        }

        formatParams.current = { ...params }
        setParamSearch(params)
        paramSearchRef.current = params

        getListTbl(params)
        setIsShowForm(false)
    }, [
        submittedStatusList,
        submittedConsiderTypeIdList,
        submittedType,
        pendingAndRiskList,
        progressOverdueList,
        onlyCurrentYearParam,
        status,
        keyword,
        profile.userId,
    ])

    return {
        displayRole,
        sortModel,
        isPage,
        isSumItem,
        listItem,
        isShowForm,
        isResearcher: checkPermission.isUserResearcher(),
        isChairman: checkPermission.isUserChairman(),
        rowPerpage,
        currentListIndexRef: currentListIndexRef,
        setListItem,
        getListItem,
        configLoading,
        isGotoTop,
        initialValueForm,
        onClickEdit: handleClickEdit,
        onClickCreate: handleClickCreate,
        onClickSearch: handleClickSearch,
        handleClickGotoTop,
        // onClickPagination: handleClickPagination,
        onClickClear: handleClickClear,
        // onClickSort: handleClickSort,
        handleScrollEnd: handleScrollEnd,
        pendingProps: {
            searchParamRef,
            afterSubmitPending: getListTbl,
        },
    }
}

export default useSearch
